export default "__VITE_ASSET__0MaMAex6__"